import request from '@/utils/request'

// Banner列表
export function getBannerList(position) {
  return request({ url: '/portal/banner/list', method: 'get', params: { position } })
}

// 产品列表
export function getProductList(params) {
  return request({ url: '/portal/product/list', method: 'get', params })
}

// 产品详情
export function getProductDetail(id) {
  return request({ url: '/portal/product/' + id, method: 'get' })
}

// 产品分类
export function getProductCategoryList() {
  return request({ url: '/portal/product/category/list', method: 'get' })
}

// 新闻列表
export function getNewsList(params) {
  return request({ url: '/portal/news/list', method: 'get', params })
}

// 新闻详情
export function getNewsDetail(id) {
  return request({ url: '/portal/news/' + id, method: 'get' })
}

// 新闻分类
export function getNewsCategoryList() {
  return request({ url: '/portal/news/category/list', method: 'get' })
}

// 案例列表
export function getCaseList(params) {
  return request({ url: '/portal/case/list', method: 'get', params })
}

// 案例详情
export function getCaseDetail(id) {
  return request({ url: '/portal/case/' + id, method: 'get' })
}

// 案例分类
export function getCaseCategoryList() {
  return request({ url: '/portal/case/category/list', method: 'get' })
}

// 企业介绍
export function getCompanyInfo() {
  return request({ url: '/portal/company', method: 'get' })
}

// 联系信息
export function getContactInfo() {
  return request({ url: '/portal/contact', method: 'get' })
}

// 提交留言
export function submitMessage(data) {
  return request({ url: '/portal/message', method: 'post', data })
}

// 导航菜单
export function getNavigation(position) {
  return request({ url: '/portal/navigation/' + position, method: 'get' })
}

// 友情链接
export function getLinkList() {
  return request({ url: '/portal/link/list', method: 'get' })
}

// 解决方案列表
export function getSolutionList() {
  return request({ url: '/portal/solution/list', method: 'get' })
}

// 站点配置
export function getSiteConfig(group) {
  return request({ url: '/portal/config/list', method: 'get', params: { group } })
}

// 统计数据
export function getSiteStats() {
  return request({ url: '/portal/stats', method: 'get' })
}

// 首页聚合数据
export function getHomeData() {
  return request({ url: '/portal/home', method: 'get' })
}
